import { Text, TextSize } from 'shared/ui/Text/Text';
import cls from './PolicyTable.module.scss';

interface PolicyTableProps {
    table?: {
        titles: string[],
        tables: {
            rightCell: string,
            leftCell: string,
        }[]
    },
}

export const PolicyTable = ({ table }: PolicyTableProps) => {
    const { titles, tables } = table;
    return (
        <div className={cls.table}>
            <Text className={cls.description}color="#353850" size={TextSize.text_20}>{titles[0]}</Text>
            <div className={cls.tableContent}>
                {
                    tables.map(({ rightCell, leftCell }: { rightCell: string, leftCell: string }) => {
                        return (
                            <div className={cls.tableRow}>
                                <div className={cls.tableCell}>
                                    <Text color="#353850" size={TextSize.text_16_600}>{rightCell}</Text>
                                </div>
                                <div className={cls.tableCell}>
                                    <Text color="#919191" size={TextSize.text_16}>{leftCell}</Text>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            <Text className={cls.description}color="#353850" size={TextSize.text_20}>{titles[1]}</Text>
        </div>
    );
};
